(function () {

    'use strict';

    angular.module('iplusjs.fahrzeugsuche.detail', [
        'lodash',
        'fuzzysort',
        'iplusjs.mapper.radioTrackBy',
        'iplusjs.list.table',
        'iplusjs.button.btn',
        'iplusjs.fahrzeugsuche',
        'iplusjs.utils.misc'
    ])
        .component('iplusjsFahrzeugsucheDetail', {
            require: {
                form: '^?form'
            },
            bindings: {
                initModel: '<ifdModel',
                onSelect: '&ifdOnSelect',
                onChange: '&ifdOnChange',
                onClose: '&ifdOnClose'
            },
            templateUrl: 'common/fahrzeugsuche/fahrzeugsucheDetail.html',
            controller: FahrzeugsucheDetailController,
            controllerAs: 'fzgsucheDetailVm'
        });

    FahrzeugsucheDetailController.$inject = [
        'lodash',
        'fuzzysort',
        'FahrzeugsucheService',
        'MiscUtilsService'
    ];
    function FahrzeugsucheDetailController(_, fuzzysort, FahrzeugsucheService, MiscUtilsService) {
        var vm = this,
            keyCodes = {
                ENTER: 13
            };

        vm.$onInit = onInit;
        vm.onKeydownSucheFahrzeug = onKeydownSucheFahrzeug;
        vm.onClickSucheFahrzeug = onClickSucheFahrzeug;
        vm.setFahrzeug = setFahrzeug;
        vm.close = close;
        vm.isErgebnisVisible = isErgebnisVisible;
        vm.onMotorleistungChanged = onMotorleistungChanged;
        vm.onLeistungsartChanged = onLeistungsartChanged;

        vm.motorleistung = function (motorleistung) {
            var leistung = _.isNaN(parseInt(motorleistung, 10)) ? null : parseInt(motorleistung, 10);

            if (arguments.length) {
                if (leistung >= 0) {
                    if (_.get(vm.model, 'leistungsart', 'kW') === 'kW') {
                        vm.motorleistungInKw = leistung;
                        vm.motorleistungInPs = Math.round(leistung * 1.359621617);
                    } else if (_.get(vm.model, 'leistungsart') === 'PS') {
                        vm.motorleistungInPs = leistung;
                        vm.motorleistungInKw = Math.round(leistung * 0.73549875);
                    }
                } else {
                    vm.motorleistungInPs = leistung;
                    vm.motorleistungInKw = leistung;
                }

                return leistung;
            } else {
                if (_.get(vm.model, 'leistungsart', 'kW') === 'kW') {
                    return vm.motorleistungInKw;
                } else if (_.get(vm.model, 'leistungsart') === 'PS') {
                    return vm.motorleistungInPs;
                }

                return null;
            }
        };

        function activate() {
            var listenDefault = {};

            vm.model = FahrzeugsucheService.getModelDetailsuche(vm.initModel);

            vm.typeaheadHerstellerOptions = {
                fuzzySearch: true,
                displayTemplate: '<%= data.display %>',
                displayProperty: 'display',
                trackByProperty: 'value',
                validation: {
                    showMessageOnValidate: true
                }
            };
            if (FahrzeugsucheService.getMerkmalWert(vm.model.hersteller)) {
                listenDefault.herstellerListe = [vm.model.hersteller];
            }

            if (FahrzeugsucheService.getMerkmalWert(vm.model.leistungsart)) {
                listenDefault.leistungsartListe = [vm.model.leistungsart];
            }

            vm.listen = _.merge(listenDefault, vm.listen);

            vm.ergebnisListeVisible = false;

            vm.ergebnisListeColumns = [{
                attr: ['hsn', 'tsn'],
                header: 'HSN/TSN'
            }, {
                attr: ['modell'],
                header: 'Modell'
            }, {
                attr: ['prodZeitraum'],
                header: 'Baujahr'
            }];
        }
        function suche() {
            vm.isLoading = true;
            vm.searchTerm = null;

            vm.onChange({
                model: vm.model
            });

            return FahrzeugsucheService.detailsuche(vm.model).then(function (ergebnis) {
                vm.ergebnisListe = ergebnis.suchergebnis.ergebnisListe;
                vm.listen = FahrzeugsucheService.getListenDetailsuche(ergebnis.suchergebnis);
            }).catch(function (error) {
            }).finally(function () {
                vm.isLoading = false;
            });
        }
        function onKeydownSucheFahrzeug(event) {
            if (event && event.keyCode === keyCodes.ENTER) {
                event.preventDefault();

                vm.ergebnisListeVisible = true;
                suche();
            }
        }
        function onClickSucheFahrzeug() {
            vm.ergebnisListeVisible = true;
            suche();
        }
        function onInit() {
            vm.isInitialLoading = true;
            activate();

            suche().finally(function () {
                vm.ergebnisListeVisible = _.size(vm.ergebnisListe) > 0;
                vm.isInitialLoading = false;
            });
        }
        function setFahrzeug(fahrzeug) {
            vm.onSelect({
                fahrzeug: fahrzeug
            });
        }
        function close() {
            vm.onClose();
        }
        function isErgebnisVisible() {
            return vm.ergebnisListeVisible;
        }

        function onMotorleistungChanged() {
            var leistungsart = _.get(vm.model, 'leistungsart') || 'kW';

            if (leistungsart === 'kW') {
                _.set(vm.model, 'leistung', vm.motorleistungInKw);
            } else if (leistungsart === 'PS') {
                _.set(vm.model, 'leistung', vm.motorleistungInPs);
            }
        }

        function onLeistungsartChanged(leistungsart) {
            var leistung = parseInt(_.get(vm.model, 'leistung'), 10);

            if (MiscUtilsService.isEmpty(leistung)) {
                return;
            }

            if (leistungsart === 'kW') {
                _.set(vm.model, 'leistung', vm.motorleistungInKw);
            } else if (leistungsart === 'PS') {
                _.set(vm.model, 'leistung', vm.motorleistungInPs);
            }
        }
    }
})();
